import { gql } from '@apollo/client';

import { OrderDetailsFragment } from '../fragments/orderDetailsFragment.gql';

/**
 * Query to fetch a single order by ID
 * Includes detailed information such as PDF URL and chat details
 *
 * @param id - The order ID
 */
export const GetOrderQuery = gql`
  query GetOrder($id: ID!) {
    order(id: $id) {
      ...OrderDetailsFragment
    }
  }
  ${OrderDetailsFragment}
`;
